import Swal from "sweetalert2";

export const notify = {
  success: (title, message = "") => {
    Swal.fire({
      title: title,
      text: message,
      icon: "success",
      iconColor: "hsl(27 85% 48%)",
      width: "280px", // Even more compact for mobile
      buttonsStyling: false,
      showClass: { popup: "animate-swal-in" },
      hideClass: { popup: "animate-swal-out" },
      customClass: {
        popup:
          "rounded-[1.8rem] bg-brand-body dark:bg-brand-dark border-none shadow-2xl p-4",
        icon: "swal2-icon-small", // Custom CSS class for small icon
        title: "text-sm font-black text-brand-dark dark:text-white pt-1",
        htmlContainer: "text-[11px] text-slate-500 mt-0.5",
        confirmButton:
          "bg-brand-gradient text-white px-5 py-2 rounded-full font-bold text-[10px] uppercase tracking-wider hover:scale-105 transition-transform active:scale-95 mt-3 shadow-lg shadow-orange-500/20",
      },
    });
  },

  error: (title, message = "") => {
    Swal.fire({
      title: title,
      text: message,
      icon: "error",
      iconColor: "#EF4444",
      width: "280px",
      buttonsStyling: false,
      showClass: { popup: "animate-swal-shake" },
      hideClass: { popup: "animate-swal-out" },
      customClass: {
        popup:
          "rounded-[1.8rem] bg-brand-body dark:bg-brand-dark border border-red-50 shadow-2xl p-4",
        icon: "swal2-icon-small",
        title: "text-sm font-black text-red-600 pt-1",
        htmlContainer: "text-[11px] text-slate-500 mt-0.5",
        confirmButton:
          "bg-red-500 text-white px-5 py-2 rounded-full font-bold text-[10px] uppercase tracking-wider hover:bg-red-600 mt-3",
      },
    });
  },

  toast: (title, icon = "success") => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
      customClass: {
        popup:
          "animate-fade-up rounded-xl shadow-xl border border-orange-50 bg-white dark:bg-brand-dark px-3 py-2",
        icon: "swal2-icon-toast-small", // Even smaller for toast
        title:
          "text-[10px] font-black dark:text-white text-slate-700 uppercase tracking-tight ml-[-5px]",
      },
    });
    Toast.fire({ icon, title });
  },
};
